import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,LoadingController,AlertController,Platform } from 'ionic-angular';

import { Http } from '@angular/http';
import { MenuController } from 'ionic-angular';
import {Updatepage} from '../updatepage/updatepage'
import { Commontask } from '../../providers/commontask'
import { Webservice } from '../../providers/webservice'
import { Storagehelper } from '../../providers/storagehelper'
import { Events } from 'ionic-angular';
import { SocialSharing } from '@ionic-native/social-sharing';

/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-dashboard',
  templateUrl: 'dashboard.html',
})
export class Dashboard extends Commontask {

	public appMenus;
	private loading;
	constructor(public navCtrl: NavController, public navParams: NavParams,public menuctrl: MenuController,public http:Http,public webservice:Webservice,public loader:LoadingController,public storage:Storagehelper,public event:Events,public alertCtrl:AlertController,public platform:Platform,public socialShare:SocialSharing) {
		super(menuctrl,event,platform,socialShare,alertCtrl);
		if(!platform.is('core') && !platform.is('mobileweb')) {
			this.navCtrl.push(Updatepage);
		}else{
			this.loadAppData();
		}
		
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad Dashboard');
	}

	ionViewWillEnter(){
		//this.loadAppData();
	}
	showInternetError(){
		this.event.publish('app:dismissLoading');	
		let alert = this.alertCtrl.create({
							    title: 'Connection error',
							    subTitle: 'Unable to conenct with the server. Check your internet conenction and try again.',
							    buttons: [ {
									        text: 'Try again',
									        role: 'Dismiss',
									        handler: () => {
									          this.loadAppData();
									        }
									      }],

							  });
		alert.present();
	}

	gotoupdate(){
		this.navCtrl.push(Updatepage)
	}

	loadAppData(){
		this.webservice.getAllData().then(()=>{
			console.log("Publishing event")
			this.event.publish('app:loadedDataFromServer');	

			console.log("change header now");
			this.event.publish("app:changeHeaderBackground")
		},(err)=>{

			console.log("Looks like no internet connection");
			this.storage.getStorageItem("pagelist").then((data)=>{	
				if(data==null){
					
			  		this.showInternetError();
				}else{
					console.log("Publishing event")
					this.event.publish('app:loadedDataFromServer');	
				}
				
			},(err)=>{
				this.showInternetError();
			})
		})
	}

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/dashboard.ts